import { IconButton, Stack, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { BatteryEventsLatest } from "./BatteryEventsLatest";
import { BatteryEventsSummary } from "./BatteryEventsSummary";
import { SelectVillage } from "../../components/SelectVillage";
import { SelectRefreshRate } from "../../components/SelectRefreshRate";
import { useVspPortalCookies } from "../../hooks/useVspPortalCookies";
import { Dashboard } from "../../enums/Dashboard";
import RefreshIcon from '@mui/icons-material/Refresh';
import { Asset } from "../../data/Asset";
import { CheckHealth } from "../Maintenance/components/CheckHealth";


export const BatteryLevelDashboard: React.FC = ( ) => {
    
    const [ batteryEventsSummaryLoaded, setBatteryEventsSummaryLoaded ] = useState< boolean >( false );
    const [ manualRefreshCount, setManualRefreshCount ] = useState<number>( 0 );
    const [ refreshCount, setRefreshCount ] = useState<number>( 0 );
    const [ refreshRate, setRefreshRate ] = useState<number>( 300_000 );
    const [ selectedEvents, setSelectedEvents ] = useState< string[ ] >( [ ] );
    const [ selectedVillage, setSelectedVillage ] = useState< string >( '' );

    const { getVillageCookies, removeDashboardCookies, setDashboardCookies } = useVspPortalCookies( );


    useEffect(() => {

        if ( !selectedVillage ) {
            
            return;

        }

        if( selectedEvents.length === 0 ) {
            
            return;

        }
    
        const interval = setInterval( ( ) => {
          
            setRefreshCount( refreshCount => refreshCount + 1 );

        }, refreshRate );

        return () => clearInterval( interval );

    }, [ refreshRate, selectedVillage, selectedEvents ]);


    const handleRefreshClick = () => { 

        setManualRefreshCount( manualRefreshCount => manualRefreshCount + 1 );
        setBatteryEventsSummaryLoaded( false );

    };


    const eventsSelectedHandler = ( events: string[ ] ): void => { 
        
        setSelectedEvents( events );
        setDashboardCookies( Dashboard.BatteryLevel, events, selectedVillage );

    };

    
    const handleSelectVillage = ( villageCode : string ) => {

        const cookiesVillage = getVillageCookies( Dashboard.BatteryLevel );
        if( cookiesVillage !== villageCode ) { // do not clear cookies during the initial page load

            removeDashboardCookies( Dashboard.BatteryLevel );

        }

        setSelectedEvents( [] );
        setSelectedVillage( villageCode );

    };

    
    return(

        <>
            
            <CheckHealth />

            <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 } sx={{ marginTop: '50px' }}>

                <SelectVillage asset={ Asset.Waio } dashboard={ Dashboard.BatteryLevel } onSelectVillage={ handleSelectVillage } />
                
                <SelectRefreshRate selectRefreshRate={setRefreshRate} />

                <Tooltip title="Refresh">
                    <IconButton onClick={ handleRefreshClick } sx={{ marginTop: '5px', height: '50px', width: '50px' }}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>

            </Stack>

            <br />

            {
                selectedVillage
                    &&
                <>
                    <BatteryEventsSummary villageCode={ selectedVillage } onEventsSelected={ eventsSelectedHandler } refreshCount={ refreshCount } manualRefreshCount={ manualRefreshCount } setBatteryEventsSummaryLoaded={ setBatteryEventsSummaryLoaded }/>
                    
                    <br />

                    {
                        batteryEventsSummaryLoaded
                            &&
                        <BatteryEventsLatest events={ selectedEvents } villageCode={ selectedVillage } refreshCount={ refreshCount } manualRefreshCount={ manualRefreshCount }/>
                    }

                </>
            }

        </>

    );

};